import React from 'react';
import { getCountryName } from './countryCodeMapping';

// Unified filter banner component
const FilterBanner = ({ filter, onClear }) => {
  // Get display label for filter type
  const getFilterTypeLabel = (type) => {
    const labels = {
      'page': 'Page',
      'entry_page': 'Entry Page',
      'exit_page': 'Exit Page',
      'country': 'Country',
      'region': 'Region',
      'city': 'City',
      'device': 'Device',
      'browser': 'Browser',
      'os': 'OS',
      'channel': 'Channel',
      'source': 'Source',
      'referrer': 'Referrer URL',
      'campaign': 'Campaign',
      'goal': 'Goal'
    };
    return labels[type] || type;
  };
  
  // Get display label for condition
  const getConditionLabel = (condition) => {
    const labels = {
      'is': 'is',
      'is_not': 'is not',
      'contains': 'contains',
      'does_not_contain': 'does not contain'
    };
    return labels[condition] || condition;
  };
  
  // Format the display value (handle pipe-separated multi-values and goal IDs).
  // For country filters we want the human-readable name in the chip ("Afghanistan")
  // rather than the raw ISO code that lives in the URL ("AF"); same for the
  // multi-country case (`AF|US` → "Afghanistan or United States").
  const formatValue = (value, type) => {
    // For goals, extract just the name (format is "id:name")
    if (type === 'goal') {
      if (value.includes('|')) {
        // Multiple goals: extract names from each
        return value.split('|').map(g => g.split(':')[1] || g).join(' or ');
      }
      // Single goal: extract name
      return value.split(':')[1] || value;
    }

    // For country filters, map each ISO code → readable country name.
    // getCountryName() falls back to the raw code if it doesn't know the country,
    // so unknown codes stay visible rather than disappearing.
    if (type === 'country') {
      if (value.includes('|')) {
        return value.split('|').map(c => getCountryName(c) || c).join(' or ');
      }
      return getCountryName(value) || value;
    }

    if (value.includes('|')) {
      return value.split('|').join(' or ');
    }
    return value;
  };

  return (
    <div className="channel-filter-banner">
      <span>
        {getFilterTypeLabel(filter.type)}
        {' '}
        {getConditionLabel(filter.condition)}
        {' '}
        <strong>{formatValue(filter.value, filter.type)}</strong>
      </span>
      <button onClick={onClear} className="clear-filter-btn" title="Clear filter">
        ✕
      </button>
    </div>
  );
};

// Container for multiple filter banners
const FilterBanners = ({ filters, onClearFilter }) => {
  if (!filters || filters.length === 0) return null;

  return (
    <div className="filter-banners-container">
      {filters.map((filter, index) => (
        <FilterBanner 
          key={index} 
          filter={filter} 
          onClear={() => onClearFilter(index)} 
        />
      ))}
    </div>
  );
};

export { FilterBanner, FilterBanners };
export default FilterBanners;
